module.exports = __webpack_public_path__ + "static/media/meinhardt-foa.bf6b2fdd.png";